import type { PersonDto } from "@/lib/benefit-types"
import { applicationIncomeAnchor, type IncomeAmountEntry } from "@/lib/income"

export interface IncomeLineDraft {
  key: string
  id?: string
  sourceOfIncome: string
  incomeType: string
  adjustment: number
  description: string
  amounts: IncomeAmountEntry[]
}

/** Only the source roster, names and income facts needed to plan the complete-roster PUT. */
export type IncomeMemberBaseline = Pick<PersonDto, "id" | "firstName" | "lastName" | "middleName" | "incomeCollection">
export const incomeMemberBaseline = ({ id, firstName, lastName, middleName, incomeCollection }: PersonDto): IncomeMemberBaseline =>
  ({ id, firstName, lastName, middleName, incomeCollection: structuredClone(incomeCollection) })

/** Capture the business month, including the existing missing-date fallback, once per edit. */
export function captureIncomeAnchor(applicationDate: string, fallback?: Date): string {
  const date = applicationIncomeAnchor(applicationDate, fallback)
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-01`
}

/** Income contracts composed into the discriminated workspace editor registry. */
export interface IncomeDraftFields {
  "member-income": { lines: IncomeLineDraft[]; fieldErrors: Record<string, string[]>; anchorDate: string; defaultIncomeType: number }
  "household-income": { incomeType: string; error: string | null; members: IncomeMemberBaseline[]; anchorDate: string }
  "no-income": { members: Pick<PersonDto, "id" | "firstName" | "lastName" | "middleName">[] }
}
